"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Skype;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Skype(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Skype"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "skype",
    d: "M85.856,57.832a38.867,38.867,0,0,0,.84-7.823A36.655,36.655,0,0,0,50.027,13.34a37.666,37.666,0,0,0-7.823.84A19.978,19.978,0,0,0,14.162,42.186a38.867,38.867,0,0,0-.84,7.823A36.655,36.655,0,0,0,49.991,86.678a37.741,37.741,0,0,0,7.823-.84A19.98,19.98,0,0,0,90,70,19.7,19.7,0,0,0,85.856,57.832ZM51.1,74.175c-11.716,0-21.522-5.216-21.522-11.61,0-2.857,1.607-5.465,5.269-5.465,5.572,0,6.09,8.019,15.736,8.019,4.59,0,7.555-2.036,7.555-4.7,0-3.34-2.858-3.858-7.5-5-11.163-2.751-21.04-3.93-21.04-15.575,0-10.574,10.466-14.485,19.486-14.485,9.842,0,19.79,3.911,19.79,9.9a5.38,5.38,0,0,1-5.412,5.679c-5.054,0-5.215-5.983-13.4-5.983-4.59,0-7.5,1.25-7.5,4.019,0,3.536,3.715,3.893,12.342,5.894,7.394,1.661,16.2,4.787,16.2,13.86C71.1,69.281,60.9,74.175,51.1,74.175Z"
  })));
}